<template>
 <a-affix :offsetTop="offsetTop" :style="autoHeight">
   <a-layout-header class="headerstyle">
      <a-col :span="24" v-if="targetPlatform == 'app' " style="box-shadow: 0 1px 0 rgba(0,0,0,.1); background: rgba(245, 246, 245, 1);">
        <a-row>
          <a-col :span="2">
          </a-col>
          <a-col v-if="item.permission[userType] && item.meta.show" :span="4" v-for="(item, index) in menu" :key="index" style="line-height: 16px;">
            <router-link :to="item.path" style="display: block;" v-if="!item.children">
              <a-icon v-if="item.meta.belowicon" :type="item.meta.belowicon" style="padding-top: 8px; padding-bottom: 6px;"/>
              <span style="display: block; font-size: 12px;padding-bottom: 4px;">
                {{item.meta.title}}
              </span>
            </router-link>
            <a-dropdown v-else="" placement="topLeft">
              <a class="ant-dropdown-link">
                <a-icon v-if="item.meta.belowicon" :type="item.meta.belowicon" style="padding-top: 8px; padding-bottom: 6px;"/>
                <span style="display: block; font-size: 12px; padding-bottom: 4px;">
                  {{username}}
                </span>
              </a>
              <a-menu slot="overlay">
                <a-menu-item v-for="(subitem, order) in item.children" :key="order">
                  <router-link :to="subitem.path"><a-icon :type="subitem.meta.icon" style="padding-right: 8px;"/>{{subitem.meta.title}}</router-link>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-col>
          <a-col :span="2">
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" v-else="" style="box-shadow: 0 1px 0 rgba(0,0,0,.1); background: rgba(245, 246, 245, 1);">
        <a-row class="max1200">
          <a-col :span="24">
            <a-row>
              <a-col :xs="5" :sm="4" :md="3" :lg="3" :xl="2" :xxl="2"> 
                <a-col :gutter="30">
                  <div class="logo"><a href="/"><img src="../assets/img/logo.png"/></a></div>
                </a-col>
                <a-col> 
                  <a-col style="height: 36px; text-align: left; padding:0px; font-size:15px; font-weight:600; line-height:44px;">助手</a-col> 
                  <a-col style="height: 11px; text-align: left; font-size: 9px; line-height: 0px; padding:0px;">{{version}}</a-col> 
                </a-col>
              </a-col> 
              <a-col>
                <keep-alive>
                  <header-tab :menu="menu" v-if="login">
                  </header-tab>
                </keep-alive>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-col>
    </a-layout-header>
  </a-affix>
</template>

<script>
import {config, TARGET_PLATFORM} from '@/util/config'
import HeaderTab from './Header.js'

export default 
{
    name: "GlobalHeader",

    components: {
      HeaderTab
    },

    data() {
      return {
        menu: [],
        login: false,
        version: config.version, 
        current: [1],
        username: "",
        uicon: '',
        userType: "",
        autoHeight: {
          height: "48px"
        },
        autoSpan: 24,
        targetPlatform: TARGET_PLATFORM,
        offsetTop: 0
      }
    },

    methods: {
      logout: function() {
        this.$store.commit('clear');
        this.$store.commit('setlogin', false);
        this.$router.push("/login");
        this.login = false;
      },
      changeTab: function(item) {
        this.current = item.keyPath;

        if (item.key == 'profile' || item.key == 'logout') {
          return;
        }

        let tab = this.menu[item.key].name
        this.tab = tab;
        for(let i = 0; i < this.menu.length; i++ ) {
          if (this.menu[i].name == tab) {
            this.current = [i];
          }
        }
        this.$store.commit('changetab', tab)
      }
    },

    created() 
    {
      if (this.targetPlatform == "app") {
        let deviceHeight = document.body.clientHeight;
        this.userType = this.$store.getters.getUsertype();
        this.autoHeight = { height: "0px"};
        this.offsetTop = deviceHeight - 45;
      } else {
        this.offsetTop = 0;
      }
      this.menu = config.children;
      this.login = this.$store.getters.isLogin();
      let tab = this.$store.getters.getTab();
      this.username = this.$store.getters.getUsername();
      this.uicon = this.$store.getters.getUIcon();
    }
  }
</script>

<style scoped>
   .headerstyle {
      background: rgba(245, 246, 245, 1);
      padding: 0px;
      height: 0px;
   }
   .logo {
      font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
      margin-right: 2px;
      height: 48px;
      line-height: 48px;
      float: left;
   }
  .logo a {
      display: inline-block;
      height: 48px;
   }
  .logo img {
      margin: 0px 0px 0px 0px;
      height: 28px;
      width: 28px;
   }
  .logo span {
      font-size: 14px;
      font-weight: 500;
   }
   .max1200 {
      max-width: 1200px; 
      margin: auto; 
      height: 100%; 
      padding: 0px 5px;
   }
   .menu-tab {
      border: 0px; 
      text-align: left; 
      font-size: 14px; 
      font-weight: 500; 
      background: rgba(245, 246, 245, 1);
   }
   .menu-item-tab {
      height: 48px; 
      padding: 0px 6px; 
      margin: 0px;
   }
   .user-menu {
      float: right;
      padding: 0px;
   }

   /deep/ .ant-menu-submenu-title{
      padding: 0px 8px;
   }
   /deep/ .ant-menu-vertical.ant-menu-sub {
      min-width: 100px;
   }
</style>
